/*
 * Who sees teacher bank details (account, IFSC, PAN/GSTIN): the payments team roles only, never
 * SUPER_USER or TEACHER_ONBOARDING on their own. Mirrors goserver canReviewPayoutDetails.
 */
import { hasAccess } from '../../../../util_functions';

export const BANK_DETAILS_ROLES = ['TEACHER_OPS_PAYMENT', 'TEACHER_PAYMENT_SUPER_USER'];

// Payment details (review queue + pop-up) and Bank payouts (eligible list, teacher-month dialog,
// deleted accounts) both show bank accounts.
export const BANK_DETAILS_TABS = ['payment-details', 'bank-payouts'];

export const BANK_DETAILS_FORBIDDEN_TEXT = "You don't have access to teacher bank details.";

// access_type is the comma-joined cms_user SET.
export const can_see_bank_details = (access_type) => hasAccess(access_type, ...BANK_DETAILS_ROLES);

// A tab-key predicate for tabs.js: bank tabs only for the payments roles, every other tab as before.
export const tab_allowed_for = (access_type) => {
  const bank = can_see_bank_details(access_type);
  return (tab_key) => bank || BANK_DETAILS_TABS.indexOf(tab_key) === -1;
};
